import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { Role } from './listRoles';

export interface UpdateRoleParams {
  id: string;
  permissions: string[];
  name?: string;
  description?: string;
}

export interface UpdateRoleResponse {
  success: boolean;
  role: Role;
  permissions: string[];
}

const updateRole: MutationFunction<
  UpdateRoleResponse,
  UpdateRoleParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockData);

  const { id, permissions, name, description } = args;
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const body: { permissions: string[]; name?: string; description?: string } = {
    permissions,
  };
  if (name !== undefined) {
    body.name = name;
  }
  if (description !== undefined) {
    body.description = description;
  }

  const response = await authTokenHttp<UpdateRoleResponse>(
    `/shared/roles/${id}`,
    {
      method: 'PUT',
      body,
    },
  );

  if (response.data) return response.data;
  throw new Error('Failed to update role');
};

export default updateRole;

const _mockData: UpdateRoleResponse = {
  success: true,
  role: {
    id: 'mock-1',
    name: 'Updated Role',
    description: 'Updated role description',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
  },
  permissions: ['loan.view_all', 'tenant.manage'],
};
